import {api,apitest} from '../api.request';
   //设计师列表
   function get1() {
    return api.get("/design/get1")
  }
    //样衣批次出款完成率 TOP50
    function get2() {
        return api.get("/design/get2")
      }
      //设计师开发成功率 TOP50
    function get3() {
        return api.get("/design/get3")
      }

//样品批次出款完成率 TOP50
const getSampleBatchPaymentCompletionRate=function(o){
  return apitest.get("/design/sampleBatchPaymentCompletionRate",o)
}
//样品开发进度节点
const getSampleDevelopmentProgressNode=function(o){
  return apitest.get("/design/sampleDevelopmentProgressNode",o)
}
//设计师开发成功率 TOP10
const getSuccessRateOfDesignerDevelopment=function(o){
  return apitest.get("/design/successRateOfDesignerDevelopment",o)
}      

  export default {
    get1,
    get2,
    get3,
    getSampleBatchPaymentCompletionRate,
    getSampleDevelopmentProgressNode,
    getSuccessRateOfDesignerDevelopment

  }